module.exports = __webpack_public_path__ + "images/application/i-checkmark-large-2f370111.svg";